import { graphql, useStaticQuery } from "gatsby";
import { SiteOptions } from "../utils/optionsTypes";

export const useOptions: () => SiteOptions = () => {
    const data = useStaticQuery(graphql`
    query {
      wpOptions {
        data {
          currency
          currency_symbol
          stripe_payment_method_types
          decimals
          comments_open
          country_default
          title
          description
          email
          email_label
          best_sellers
          image{
            id
            url
            alt
            name
            localFile {
              childrenImageSharp {
                gatsbyImageData (
                  breakpoints: [300, 380, 480, 550]
                  quality: 80
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
          disclaimer{
            title
            description
          }
          old{
            title
            description
            email
            email_label
            name
            job
            image{
                id
                url
                alt
                name
                localFile {
                childrenImageSharp {
                    gatsbyImageData (
                    breakpoints: [300, 380, 480, 550]
                    quality: 80
                    formats: [AUTO, WEBP]
                    )
                }
                }
            }
            disclaimer{
                title
                description
            }
          }
          description_email_completed
          sale_end_date
          phone
          phone_title
        }
      }
    }
  `);

    return data;
};
